module.exports = "/images/exclamation-circle-solid.svg?09708c1d246d28aba42445b9de66b2fc";